import styled from 'styled-components'

export const IframeAvisoPrivacidade = styled.iframe`
  height: 80vh;
  width: 100%;
`
